import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface MediaEntry {
  id: string;
  media: string;
}

interface State {
  [storeName: string]: MediaEntry[];
}

interface UpdateCachedMediaListPayload {
  storeName: string;
  entries: MediaEntry[];
}

const initialState: State = {};

const cachedMediaSlice = createSlice({
  name: 'cachedMedia',
  initialState,
  reducers: {
    updateCachedMediaList: (state, action: PayloadAction<UpdateCachedMediaListPayload>) => {
      const {storeName, entries} = action.payload as UpdateCachedMediaListPayload;

      // If there are no entries at all, clear out this storeName key.
      if (entries.length === 0) {
        const {[storeName]: _, ...rest} = state;
        return rest;
      }
      state[storeName] = entries;
    },
  },
});

export const cachedMediaReducer = cachedMediaSlice.reducer;
export const {updateCachedMediaList} = cachedMediaSlice.actions;
